<form class="dock-type-list">
  <mat-form-field>
    <mat-icon matSuffix>arrow_drop_down</mat-icon>
    <input type="text" [placeholder]="placeHolder" aria-label="Number" matInput [formControl]="myControl"
      [matAutocomplete]="auto">
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
      <mat-option *ngFor="let dockType of filteredDockTypes | async" [value]="dockType">
        {{dockType?.name}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</form>

<!-- <form class="dockType-list">
  <mat-form-field>
    <mat-select [formControl]="myControl">
      <mat-option *ngFor="let dockType of companies" [value]="dockType">
         {{dockType?.name}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</form> -->